import { AbstractPmsApiService } from "./abstract.service";
import { Property, NumberingSettings } from "../models";

/**
 * @class NumberingSettingsPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<NumberingSettings>}
 */

export class NumberingSettingsPmsApiService extends AbstractPmsApiService{
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        return '/property/:propertyId/numbering-settings(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {NumberingSettings}
     * @protected
     */
     newModel(attributes, ...params) {
        
        return new NumberingSettings(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<NumberingSettings>>}
     */
     get (params = {}, property = null) {
        
        const url = this.url({propertyId: property ? property.id : 0});
        
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {NumberingSettings} numberingSettings
     * @returns {Promise.<NumberingSettings>}
     */
     update(numberingSettings) {
        
        const url = this.url({
            propertyId: numberingSettings.property_id,
            id:         numberingSettings.id
        });
        
        return this.http
                   .put(url, numberingSettings.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/numbering-settings.service.js